import axios from "axios";

/*
  PRODUCTION - KAKOTORA DATE LOCAL FIX

  Masalah:
  - Input tanggal 13, setelah save lalu buka ulang menjadi 12.
  - Penyebab umum: data DATE dari MySQL menjadi ISO UTC,
    lalu frontend mengambil tanggal dengan cara yang membuat mundur 1 hari.

  Fix:
  - Semua response /api/kakotora dinormalisasi.
  - Field tanggal/date/target/realisasi diformat pakai tanggal lokal browser.
  - Tidak mengubah database.
*/

(function () {
  if (typeof window === "undefined") return;

  const path = window.location.pathname || "";

  // Jangan aktif di staging/public-display.
  const isStaging =
    path === "/staging" ||
    path.startsWith("/staging/") ||
    path === "/staging-public" ||
    path.startsWith("/staging-public/");

  if (isStaging) return;
  if (window.__KAKOTORA_DATE_LOCAL_FIX_PRODUCTION__) return;

  window.__KAKOTORA_DATE_LOCAL_FIX_PRODUCTION__ = true;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function localYmdFromDate(d) {
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;

    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate())
    );
  }

  function normalizeDateOnly(value) {
    if (value === undefined || value === null || value === "") return value;

    if (value instanceof Date) {
      return localYmdFromDate(value) || value;
    }

    const raw = String(value).trim();
    if (!raw) return value;

    // Kalau sudah murni YYYY-MM-DD, jangan diubah.
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      return raw;
    }

    // ISO date dari backend, contoh:
    // 2026-07-12T17:00:00.000Z harus tampil 2026-07-13 di WIB.
    if (/^\d{4}-\d{2}-\d{2}[T\s]/.test(raw)) {
      const d = new Date(raw);
      return localYmdFromDate(d) || raw.slice(0, 10);
    }

    return value;
  }

  function isDateKey(key) {
    const k = String(key || "").toLowerCase();

    return (
      k.includes("date") ||
      k.includes("tanggal") ||
      k.includes("tgl") ||
      k.includes("target") ||
      k.includes("realisasi") ||
      k.includes("actual") ||
      k.includes("deadline") ||
      k.includes("due")
    );
  }

  function normalizeDatesDeep(value, key) {
    if (Array.isArray(value)) {
      return value.map((item) => normalizeDatesDeep(item, key));
    }

    if (value && typeof value === "object" && !(value instanceof Date)) {
      Object.keys(value).forEach((k) => {
        value[k] = normalizeDatesDeep(value[k], k);
      });

      return value;
    }

    if (isDateKey(key)) {
      return normalizeDateOnly(value);
    }

    return value;
  }

  function isKakotoraUrl(url) {
    const u = String(url || "").toLowerCase();
    return u.includes("/kakotora");
  }

  function attach(instance) {
    if (!instance || instance.__KAKOTORA_DATE_LOCAL_FIX_ATTACHED__) return instance;

    instance.__KAKOTORA_DATE_LOCAL_FIX_ATTACHED__ = true;

    instance.interceptors.response.use((res) => {
      const fullUrl = `${res?.config?.baseURL || ""}${res?.config?.url || ""}`;

      if (isKakotoraUrl(fullUrl) && res && res.data) {
        res.data = normalizeDatesDeep(res.data, "");
      }

      return res;
    });

    instance.interceptors.request.use((config) => {
      const fullUrl = `${config?.baseURL || ""}${config?.url || ""}`;

      if (isKakotoraUrl(fullUrl) && config && config.data) {
        config.data = normalizeDatesDeep(config.data, "");
      }

      return config;
    });

    return instance;
  }

  attach(axios);

  const oldCreate = axios.create.bind(axios);

  axios.create = function patchedCreate(config) {
    return attach(oldCreate(config));
  };

  window.__CHECK_KAKOTORA_DATE_FIX_PROD__ = function (value) {
    return {
      input: value || "2026-07-12T17:00:00.000Z",
      output: normalizeDateOnly(value || "2026-07-12T17:00:00.000Z"),
      note: "Output harus menjadi tanggal lokal browser, contoh WIB: 2026-07-13",
    };
  };
})();
